import React from 'react';
import { SkeletonRegistryCategory } from '../../../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonRegistryItem } from '../../../../../registry/skeleton/SkeletonRegistryItem';
import { Actor_ } from '../../../../../components/actor/Actor_';
export class SkeletonRegistryDraftQuestionPart extends SkeletonRegistryCategory {
    label = 'QuestionPart';
    constructor(parent) {
        super(parent);
        super.init();
    }
    draftQuestionPartStructure_unboxed = () => new SkeletonRegistryItem({
        label: 'QuestionPart Content Actors ohne Box',
        jsx: ({ question }) => {
            if (!question)
                return null;
            return question.questionPart.inner.aspectContent.global.activeContentAts.map(at => React.createElement(Actor_, { actor: at, key: at.id }));
        }
    });
    questionsquestionPart = () => new SkeletonRegistryItem({
        label: 'QuestionPart',
        jsx: ({ question }) => {
            if (!question)
                return null;
            return React.createElement(Actor_, { actor: question.questionPart, key: question.questionPart.id });
        }
    });
}
